<template>
    <svg aria-hidden="true" focusable="false" width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Vector 18" d="M1.43099e-07 0L0 12L10 6L1.43099e-07 0Z" fill="black" />
    </svg>
</template>
